<template>
    <div class="traceability-contract-view-page">
        <base-header
            :titulo="translate('traceabilityReport.title')"
            :btn-texto="translate('traceabilityReport.individual_record')"
            :exibeBotao='true'
            icon='el-icon-document-add'
            @btnHeaderClicado='newRecord()'
        />
        <div class="view-container-wrapper">
            <div class="content">
                <filters @changeFilters="changeFilters" />
                <totalizers />
                <export-list-table :filters="filters" />
            </div>
        </div>
    </div>
</template>
<script>
import RastreabilidadeExportacaoService from '@/services/RastreabilidadeExportacaoService';

export default {
    data() {
        return {
            filters: {}
        };
    },
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Filters: () => import('@/modules/traceability-report/views/pages/view-exports/components/filters/index.vue'),
        Totalizers: () => import('@/modules/traceability-report/views/pages/view-exports/components/totalizers/index.vue'),
        ExportListTable: () => import('@/modules/traceability-report/views/pages/view-exports/components/report-list/index.vue')
    },
    methods: {
        translate(key, params = {}) {
            const base = 'relatorio_rastreabilidade.messages';
            return this.$t(`${base}.${key}`, params);
        },
        async newRecord() {
            try {
                await RastreabilidadeExportacaoService.checkEudrAccess();
                this.$router.push({ name: 'RelatorioRastreabilidadeCadastro' });
            } catch (error) {
                const code = error && error.response && error.response.data && error.response.data.message;
                const message = code
                    ? this.translate('individual_record.error.' + code)
                    : this.translate('individual_record.error.error_message');
                this.$notify.error({ message, duration: 6000 });
            }
        },
        changeFilters(filters) {
            this.filters = filters;
        }
    }
};
</script>
<style scoped lang="scss">
.traceability-contract-view-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}
</style>
